export const apirkyc = "https://rekycbe.mynt.in/"
// export const apirkyc = "http://192.168.5.207:5000/"
// export const apirkyc = "https://rekycuat.mynt.in/"

export const apiekyc = "https://ekycbe.mynt.in/zebu"
export const apirej = "https://ekycbe.mynt.in"
export const apikra = "https://ekycbe.mynt.in/"
export const apidkyc = "https://ekycbe.mynt.in/dashboard"
export const apiinsbo = "https://ekycbe.mynt.in/cdsl"
export const apidoc = "https://rekycbe.mynt.in/file"
export const apiekycdoc = "https://ekycbe.mynt.in/file"

export const apiexkyc = "http://192.168.5.132:5003"
export const sessapi = "https://sess.mynt.in/"

export const apApiBase = "https://a1.zebuetrade.com/ap/v2/"
// export const apApiBase = "http://192.168.5.107:5005"

// export const apiekyc = "http://192.168.5.179:5005/zebu"
// export const apidkyc = "http://192.168.5.179:5005/zebu"
// export const apiinsbo = "http://192.168.5.179:5005/"
